import React from 'react';
import Fade from 'react-reveal/Fade';
import cls from 'classnames';

export const V360Info = (({
	className,
	classes,
	fullname,
	details,
	...props
}) => {
	return (
		<header
			{...props}
			className={cls(classes.v360Info, className)}>
			<Fade bottom>
				<h3
					className={cls(classes.v360InfoTitle)}
					dangerouslySetInnerHTML={{
						__html: fullname,
					}}
				/>
			</Fade>
			<Fade cascade bottom>
				<p
					className={cls(classes.v360InfoText)}
					dangerouslySetInnerHTML={{
						__html: `• ${details.join('<br/>• ')}`,
					}}
				/>
			</Fade>
		</header>
	);
});

export default React.memo(V360Info);
